/**
 * Payments service (B5) — the ONLY client path to Stripe.
 *
 * The client never sends an amount. The edge function resolves the card fee from
 * programme config and the database refuses any amount that equals fee +
 * intended load, so a compromised client cannot change what is charged.
 */
import { supabase } from "@/integrations/supabase/client";

export interface CardPaymentIntent {
  paymentIntentId: string;
  clientSecret: string;
  publishableKey: string | null;
  amountCents: number;
  currency: string;
  captureMethod: string;
  status: string;
}

export async function createCardPayment(args: {
  programId: string;
  attemptId: string;
  quantity?: number;
  /** Bank-handoff figure. Sent as METADATA only — never part of the amount. */
  intendedLoadAmountCents?: number | null;
}): Promise<{ data: CardPaymentIntent | null; error: Error | null }> {
  const { data, error } = await supabase.functions.invoke("create-card-payment", {
    body: {
      programId: args.programId,
      attemptId: args.attemptId,
      quantity: args.quantity ?? 1,
      intendedLoadAmountCents: args.intendedLoadAmountCents ?? 0,
    },
  });
  if (error) return { data: null, error: error as Error };
  if ((data as any)?.error) return { data: null, error: new Error((data as any).error) };
  return { data: data as CardPaymentIntent, error: null };
}
